import { useState } from "react";
import { Layout } from "@/components/layout/Layout";
import { MaterialCard, Material } from "@/components/materials/MaterialCard";
import { sampleMaterials } from "@/data/sampleMaterials";
import { Heart } from "lucide-react";
import { toast } from "sonner";

export default function Favorites() {
  const [materials, setMaterials] = useState<Material[]>(
    sampleMaterials.filter((m) => m.isFavorite)
  );

  const handleFavorite = (id: string) => {
    setMaterials((prev) => prev.filter((m) => m.id !== id));
    toast.success("Removed from favorites");
  };

  const handleAddToProject = (id: string) => {
    toast.success("Material added to project");
  };

  return (
    <Layout>
      <div className="container mx-auto px-4 py-8 lg:py-12">
        {/* Header */}
        <div className="mb-8">
          <h1 className="mb-2 font-serif text-3xl font-semibold text-foreground sm:text-4xl">
            Favorites
          </h1>
          <p className="text-lg text-muted-foreground">
            Your saved materials for quick access
          </p>
        </div>

        {/* Grid */}
        {materials.length > 0 ? (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {materials.map((material) => (
              <MaterialCard
                key={material.id}
                material={{ ...material, isFavorite: true }}
                onFavorite={handleFavorite}
                onAddToProject={handleAddToProject}
              />
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-24 text-center">
            <div className="mb-4 rounded-full bg-muted p-4">
              <Heart className="h-8 w-8 text-muted-foreground" />
            </div>
            <h3 className="mb-2 font-serif text-xl font-medium text-foreground">
              No favorites yet
            </h3>
            <p className="text-muted-foreground">
              Browse materials and click the heart icon to save your favorites
            </p>
          </div>
        )}
      </div>
    </Layout>
  );
}
